module.exports = __webpack_public_path__ + "img/study_stacontent_icon3.3f85a2d1.png";